import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    codelist: [],
    urllist: [],
    updatePosterDialog: false,
    totalCount: 0,
  },
  getters: {
    filterList: state => state.codelist
  },
  mutations: {
    setcodelist(state, payload) {
      state.codelist = payload;
    },
    seturllist(state, payload) {
      state.urllist = payload;
    },

    setupdatePosterDialog(state, payload) {
      state.updatePosterDialog = payload;
    },
    setTotalCount(state, payload) {
      state.totalCount = payload
    }
  },
  actions: {
    async getUrlList({ commit }, params) {
      const res = await api.getUrlList(params)
      commit('seturllist', res.data.list)
      commit('setTotalCount', res.data.totalCount)
      return res
    },

    async delOne({ commit }, id) {
      const res = await api.delOne(id);
      return res;
    },
    async addOne({ commit }, data) {
      const res = await api.addOne(data);
      return res;
    },
    async updateOne({ commit }, data) {
      const res = await api.updateUrl(data)
      return res
    }

  },
};

appStore.registerModule("nodeConfigStore", store);
